import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTasksWidgetEmptyState = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 226,
	height: 176,
	viewBox: "0 0 226 176",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tasks-empty-state-linear-gradient",
			x1: .624,
			y1: .178,
			x2: .223,
			y2: 1.181,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#7284fa"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .567,
					stopColor: "#9f7de5"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fb6fbb"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tasks-empty-state-linear-gradient-2",
			x1: -.311,
			y1: 1.934,
			x2: -.31,
			y2: 1.934,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#818c44"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#26264f"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#26264f"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_17364",
				"data-name": "Rectangle 17364",
				width: 226,
				height: 176,
				transform: "translate(392 757)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-2",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37734",
				"data-name": "Path 37734",
				d: "M7.469,14.55,1.594,10.813,0,13.32l8.212,5.223,12.4-16.777L18.22,0Z",
				transform: "translate(0)",
				fill: "#7dd3c2"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16350",
				"data-name": "Rectangle 16350",
				width: 94.944,
				height: 142.684,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-5",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37829",
				"data-name": "Path 37829",
				d: "M482.753,633.786l-3.416,2.531.818,2.815,3.466-2.2,1.261-3.939Z",
				transform: "translate(-479.338 -632.99)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tasks-empty-state-linear-gradient-3",
			x1: -6.205,
			y1: 9.977,
			x2: -6.191,
			y2: 9.977,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#ffc444"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#f36f56"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#f36f56"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-6",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37830",
				"data-name": "Path 37830",
				d: "M445.755,1247.753s1.868,4.7,1.377,6.785a21.042,21.042,0,0,0,3.3-.295,22.746,22.746,0,0,1-.964-3.206,31.524,31.524,0,0,1-.2-3.756Z",
				transform: "translate(-445.755 -1247.281)",
				fill: "#fcdcbd"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-8",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37832",
				"data-name": "Path 37832",
				d: "M190.306,1266.2s.159,1.54.478,3.824-.876,8.038-.876,8.038l1.3-2.242,2.163-1.888s1.811,1.175.59-.472c-1.434-1.646-.307-7.526-.307-7.526Z",
				transform: "translate(-189.908 -1265.931)",
				fill: "#fcdcbd"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-9",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37833",
				"data-name": "Path 37833",
				d: "M158.15,622.276s-3.027,2.708-3.027,13.861,1.434,35.369,1.434,35.369l2.295,17.338a15.168,15.168,0,0,0,3.972-.393c1.434-6.532,3.77-17.582,2.655-26.822C165,651.59,169.462,639,169.462,639s3.824,12.745,6.532,19.118,7.865,26.337,8.343,27.771c3.169.287,4.523-.551,4.523-.551s-2.032-21.485-3.944-29.61-1.753-27.721-4.939-33.3a26.247,26.247,0,0,0-9.218-1.317,79.365,79.365,0,0,0-12.608,1.158",
				transform: "translate(-155.123 -621.118)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tasks-empty-state-linear-gradient-4",
			x1: -.467,
			y1: 1.174,
			x2: -.464,
			y2: 1.174,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#311944"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#893976"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-10",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37834",
				"data-name": "Path 37834",
				d: "M158.15,622.276s-3.027,2.708-3.027,13.861,1.434,35.369,1.434,35.369l2.295,17.338a15.168,15.168,0,0,0,3.972-.393c1.434-6.532,3.77-17.582,2.655-26.822C165,651.59,169.462,639,169.462,639s3.824,12.745,6.532,19.118,7.865,26.337,8.343,27.771c3.169.287,4.523-.551,4.523-.551s-2.032-21.485-3.944-29.61-1.753-27.721-4.939-33.3a26.245,26.245,0,0,0-9.218-1.317,79.368,79.368,0,0,0-12.608,1.158",
				transform: "translate(-155.123 -621.118)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "tasks-empty-state-linear-gradient-5",
			x1: -.012,
			y1: 1.105,
			x2: -.011,
			y2: 1.105,
			xlinkHref: "#tasks-empty-state-linear-gradient-4"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-12",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16339",
				"data-name": "Rectangle 16339",
				width: 33.736,
				height: 64.74,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-13",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37835",
				"data-name": "Path 37835",
				d: "M173.875,642.71c.944,6.135,2.832,9.439,7.551,13.686,3.775,2.832.944,8.967,2.36,13.687.472,1.416,1.888,2.832,2.36,4.247,1.756,3.513.116,7.809.912,11.528a5.055,5.055,0,0,0,1.8-.516s-2.032-21.485-3.944-29.61-1.753-27.721-4.939-33.3c-7.169-2.868-21.827-.159-21.827-.159s-3.027,2.708-3.027,13.861c0,.9.01,1.9.027,2.954,3.143,2.781,9.57,3.4,13.534.316a1.872,1.872,0,0,1,.758-.343l.021-.059.017.055c1.8-.329,3.987,2.013,4.4,3.651",
				transform: "translate(-155.123 -621.118)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "tasks-empty-state-linear-gradient-6",
			x1: -.019,
			y1: 1.147,
			x2: -.017,
			y2: 1.147,
			xlinkHref: "#tasks-empty-state-linear-gradient-4"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-14",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37839",
				"data-name": "Path 37839",
				d: "M304.455,267.861c-5.7,1.965-8.652,11.777-6.049,14.658.8.881,1.836.808,3.332.734a15.287,15.287,0,0,1,5.5.554,17.6,17.6,0,0,1,9.636,7.324c3.954,6.529,1.508,13.687,1.116,14.777l3.473-1.3a25.184,25.184,0,0,0,3.112-8.712,25.8,25.8,0,0,0-2.854-16.139c-2.778-4.974-9.181-12.258-15.086-12.258a6.654,6.654,0,0,0-2.181.36",
				transform: "translate(-297.451 -267.501)",
				fill: "#7284fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-15",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37840",
				"data-name": "Path 37840",
				d: "M132.738,259.027c-2.64,2.639.028,5.618-.545,12.52-.878,10.567-7.611,13.149-8.118,23.87a27.377,27.377,0,0,0,.915,8.343,28.81,28.81,0,0,0,7.466,6.61c5.195,3.16,8.207,2.609,15.667,4.651,12.2,3.34,13.289,7.317,19.339,6.3,6.115-1.024,11.481-6.17,10.833-9-.388-1.692-2.853-1.213-5.692-3.794-3.658-3.327-2.247-6.5-5.028-10.078-3.995-5.135-9.56-2-12.964-6.446-3.444-4.5-2.078-13.373.825-18.209,1.9-3.158,2.708-6.86,4.321-10.171a2.3,2.3,0,0,0,.221-1.29c-.262-2.157-3.857-3.327-6.58-4.185a32.466,32.466,0,0,0-8-1.486c-1.216-.049-2.373-.083-3.465-.083-4.063,0-7.228.474-9.2,2.443",
				transform: "translate(-124.045 -256.584)",
				fill: "url(#tasks-empty-state-linear-gradient)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-16",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37841",
				"data-name": "Path 37841",
				d: "M286.785,251.98a5.414,5.414,0,0,0,4.771,2.873,5.947,5.947,0,0,0,4.395-2.065l-.773-.564a5.438,5.438,0,0,1-3.326,1.132c-3.639-.191-3.935-1.724-3.935-1.724Z",
				transform: "translate(-286.785 -251.632)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tasks-empty-state-linear-gradient-8",
			x1: -3.047,
			y1: 15.591,
			x2: -3.036,
			y2: 15.591,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#e38ddd"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .004,
					stopColor: "#e38ddd"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#9571f6"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-18",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37844",
				"data-name": "Path 37844",
				d: "M316.928,151.818a2.648,2.648,0,0,0-.582,2.389c.109.448.249.5.229.789-.056.825-1.559,1.184-1.475,1.6.06.3.842.188.976.561.148.409-.711.76-1.08,1.787-.692.463-1.128,1.614-1.279,3.156a14.039,14.039,0,0,0,.435,5.493c1.876,6.056,3.343,10.9,7.123,14.116,4.967,4.23,8.909,1.424,18.027,3.76,13.262,3.4,14.937,11.9,21.192,11.051,8.179-1.109,16.223-17.129,16.237-29.2v-.062c0-4.441-1.1-8.341-3.68-10.761-5.425-5.089-18.854-4.963-26.928.49-3.5,2.362-5.292,5.151-9.425,5.386-3.142.178-8.139-1-10.771-4.407-.332-.429-1.658-2.227-3.649-4.494a5.349,5.349,0,0,0-3.1-2.15,4.253,4.253,0,0,0-.681-.061,2.188,2.188,0,0,0-1.563.559",
				transform: "translate(-313.629 -151.259)",
				fill: "url(#tasks-empty-state-linear-gradient-2)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-19",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37845",
				"data-name": "Path 37845",
				d: "M1.9,73.137A25.183,25.183,0,0,0,0,82.193a25.8,25.8,0,0,0,5.034,15.6c3.861,5.116,12.666,12.5,18.731,9.426,5.381-2.727,6.96-12.85,3.988-15.347-.971-.816-2.069-.515-3.708-.215a14.89,14.89,0,0,1-5.217.146A17.441,17.441,0,0,1,8.284,85.862,17.464,17.464,0,0,1,4.716,73.217a4.473,4.473,0,0,0-1.375-.267l-.155,0a4.478,4.478,0,0,0-1.291.19",
				transform: "translate(0 -72.947)",
				fill: "#7284fa"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-21",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16348",
				"data-name": "Rectangle 16348",
				width: 52.841,
				height: 38.79,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "tasks-empty-state-clip-path-22",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37846",
				"data-name": "Path 37846",
				d: "M167.647,548.339c-1.467-1.5.148-4.538-2.02-6.793-2.012-2.093-4.289-.4-7.528-2.2-4.154-2.31-3.009-6.539-6.977-8.813-2.853-1.635-4.194.123-8.629-.734a17.958,17.958,0,0,1-12.485-9.364,16.094,16.094,0,0,1-1.6-6.682c-1.992,3.558-4.057,6.968-4.329,12.722a27.374,27.374,0,0,0,.915,8.343,28.807,28.807,0,0,0,7.466,6.61c5.195,3.16,8.207,2.609,15.667,4.651,12.2,3.34,13.289,7.317,19.339,6.3a16.379,16.379,0,0,0,9.423-5.333c-5.639,2.51-8.175,2.385-9.24,1.293",
				transform: "translate(-124.045 -513.749)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tasks-empty-state-linear-gradient-10",
			x1: -.099,
			y1: 1.702,
			x2: -.098,
			y2: 1.702,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#ff9085"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fb6fbb"
			})]
		})
	] }), /* @__PURE__ */ _jsx("g", {
		id: "Mask_Group_14589",
		"data-name": "Mask Group 14589",
		transform: "translate(-392 -757)",
		clipPath: "url(#tasks-empty-state-clip-path)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_14028",
			"data-name": "Group 14028",
			transform: "translate(-6750.169 -1900.649)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_39280",
					"data-name": "Path 39280",
					d: "M89.438.037C117.924.8,146.785,13.191,154.3,42.117c3.7,14.224-1.156,29.314,3.473,43.349,4.681,14.192,19.534,18.341,29.71,27.839,12.286,11.469,15.957,31.353,7.76,46.075-8.846,15.888-30.233,23.825-47.618,17.671-15-5.311-25.159-18.859-38.445-27.505a65.85,65.85,0,0,0-39.3-10.415c-7.961.452-15.847,2.352-23.81,1.961C24.035,140.01,6.06,120.708,1.493,99.577S3.386,56.363,13.407,37.121c3.849-7.391,8.339-14.652,14.755-20.073C37.542,9.121,50.03,5.909,62.044,2.932A103.563,103.563,0,0,1,89.438.037Z",
					transform: "matrix(0.643, -0.766, 0.766, 0.643, 7115.394, 2759.58)",
					fill: "#7b8efa",
					opacity: .137
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_14026",
					"data-name": "Group 14026",
					transform: "translate(7189.155 2659.406)",
					children: [/* @__PURE__ */ _jsx("g", {
						id: "Group_13226",
						"data-name": "Group 13226",
						transform: "translate(0 0)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_37872",
							"data-name": "Path 37872",
							d: "M1126.785,992.652a23.878,23.878,0,1,1-23.878-23.878,23.878,23.878,0,0,1,23.878,23.878",
							transform: "translate(-1079.028 -968.774)",
							fill: "#dbe0fd"
						})
					}), /* @__PURE__ */ _jsx("g", {
						id: "Group_13227",
						"data-name": "Group 13227",
						transform: "translate(14.56 15.105) rotate(2)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_12930",
							"data-name": "Group 12930",
							transform: "translate(0 0)",
							clipPath: "url(#tasks-empty-state-clip-path-2)",
							children: /* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_16259",
								"data-name": "Rectangle 16259",
								width: 24.639,
								height: 23.165,
								transform: "translate(-4.55 1.194) rotate(-14.697)",
								fill: "#7dd3c2"
							})
						})
					})]
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_14027",
					"data-name": "Group 14027",
					transform: "translate(7225.746 2686.913)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_13140",
						"data-name": "Group 13140",
						clipPath: "url(#tasks-empty-state-clip-path-3)",
						children: [
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13101",
								"data-name": "Group 13101",
								transform: "translate(0 0)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13100",
									"data-name": "Group 13100",
									clipPath: "url(#tasks-empty-state-clip-path-3)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_37828",
										"data-name": "Path 37828",
										d: "M15.44,8.078a6.037,6.037,0,0,0,.981-3.093c.076-2.87-2.053-5.108-2.339-4.98-.154.069.041.91.151,1.283.228.776.473.851.453,1.207-.042.734-1.1.762-1.66,1.735a2.625,2.625,0,0,0,0,2.49A2.966,2.966,0,0,0,15.44,8.078",
										transform: "translate(-11.421 0)",
										fill: "#fcdcbd"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13103",
								"data-name": "Group 13103",
								transform: "translate(48.668 64.269)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13102",
									"data-name": "Group 13102",
									clipPath: "url(#tasks-empty-state-clip-path-5)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16332",
										"data-name": "Rectangle 16332",
										width: 7.672,
										height: 7.949,
										transform: "translate(-2.416 1.175) rotate(-25.934)",
										fill: "url(#tasks-empty-state-linear-gradient-3)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13105",
								"data-name": "Group 13105",
								transform: "translate(45.258 126.639)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13104",
									"data-name": "Group 13104",
									clipPath: "url(#tasks-empty-state-clip-path-6)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16333",
										"data-name": "Rectangle 16333",
										width: 4.68,
										height: 7.256,
										fill: "#fcdcbd"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13107",
								"data-name": "Group 13107",
								transform: "translate(0 0)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13106",
									"data-name": "Group 13106",
									clipPath: "url(#tasks-empty-state-clip-path-3)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_37831",
										"data-name": "Path 37831",
										d: "M190.005,1359.986a1.475,1.475,0,0,1,.353.864,1.4,1.4,0,0,1-.106.578c-.319.838-.819.949-1.359,1.838-.33.543-.268.707-.57.953a1.982,1.982,0,0,1-1.3.347,23.083,23.083,0,0,1-3-.17q1.006-1.3,2.142-2.628.5-.583,1-1.139l1.971-.666.872.023",
										transform: "translate(-165.341 -1221.883)",
										fill: "#26264f"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13109",
								"data-name": "Group 13109",
								transform: "translate(19.282 128.533)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13108",
									"data-name": "Group 13108",
									clipPath: "url(#tasks-empty-state-clip-path-8)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16335",
										"data-name": "Rectangle 16335",
										width: 5.272,
										height: 12.127,
										fill: "#fcdcbd"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13111",
								"data-name": "Group 13111",
								transform: "translate(15.75 63.064)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13110",
									"data-name": "Group 13110",
									clipPath: "url(#tasks-empty-state-clip-path-9)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16336",
										"data-name": "Rectangle 16336",
										width: 33.736,
										height: 67.81,
										transform: "translate(0 0)",
										fill: "url(#tasks-empty-state-linear-gradient-4)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13113",
								"data-name": "Group 13113",
								transform: "translate(15.75 63.064)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13112",
									"data-name": "Group 13112",
									clipPath: "url(#tasks-empty-state-clip-path-10)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16337",
										"data-name": "Rectangle 16337",
										width: 63.677,
										height: 75.523,
										transform: "translate(-29.807 17.746) rotate(-30.768)",
										fill: "url(#tasks-empty-state-linear-gradient-5)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13120",
								"data-name": "Group 13120",
								transform: "translate(0 0)",
								children: /* @__PURE__ */ _jsxs("g", {
									id: "Group_13119",
									"data-name": "Group 13119",
									clipPath: "url(#tasks-empty-state-clip-path-3)",
									children: [
										/* @__PURE__ */ _jsx("g", {
											id: "Group_13118",
											"data-name": "Group 13118",
											transform: "translate(15.75 63.064)",
											opacity: .25,
											style: {
												mixBlendMode: "multiply",
												isolation: "isolate"
											},
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_13117",
												"data-name": "Group 13117",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_13116",
													"data-name": "Group 13116",
													clipPath: "url(#tasks-empty-state-clip-path-12)",
													children: /* @__PURE__ */ _jsx("g", {
														id: "Group_13115",
														"data-name": "Group 13115",
														transform: "translate(0 0)",
														children: /* @__PURE__ */ _jsx("g", {
															id: "Group_13114",
															"data-name": "Group 13114",
															clipPath: "url(#tasks-empty-state-clip-path-13)",
															children: /* @__PURE__ */ _jsx("rect", {
																id: "Rectangle_16338",
																"data-name": "Rectangle 16338",
																width: 62.9,
																height: 74.218,
																transform: "matrix(0.859, -0.512, 0.512, 0.859, -29.139, 15.798)",
																fill: "url(#tasks-empty-state-linear-gradient-6)"
															})
														})
													})
												})
											})
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_37836",
											"data-name": "Path 37836",
											d: "M450.675,1336.313s-.466,0-.427.6-.21,2.67,2.157,2.767a7.247,7.247,0,0,0,2.809-.167,19.392,19.392,0,0,0-.621-1.979l-.757-.97-2.037-.213Z",
											transform: "translate(-404.531 -1200.634)",
											fill: "#26264f"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_37837",
											"data-name": "Path 37837",
											d: "M456.63,1307.565a7.529,7.529,0,0,0-.611-1.919c-.418-.94-.075-1.292-.474-2.148a2.55,2.55,0,0,0-.564-.855,2.446,2.446,0,0,0-1.671-.637,1.7,1.7,0,0,0-.787.185,1.837,1.837,0,0,0-.708.747,8.3,8.3,0,0,0-.57,1.691,4.185,4.185,0,0,0-.211,1.092c.621,0,3.007.1,3.511.466a1.977,1.977,0,0,1,.757,1.611c0,.621.311.912.621.892a1.019,1.019,0,0,0,.708-1.125",
											transform: "translate(-405.239 -1169.809)",
											fill: "#444b8c"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_37838",
											"data-name": "Path 37838",
											d: "M185.768,1331.917c.533.008.924.432,1.219,1.455s1.711,1.927.059,1.711-2.852,2.124-3.441,2.989-2.174,1.634-2.134.788.738-1.241.935-2.106,2.147-4.856,3.363-4.838",
											transform: "translate(-163.045 -1196.684)",
											fill: "#444b8c"
										})
									]
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13122",
								"data-name": "Group 13122",
								transform: "translate(30.201 27.16)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13121",
									"data-name": "Group 13121",
									clipPath: "url(#tasks-empty-state-clip-path-14)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16341",
										"data-name": "Rectangle 16341",
										width: 40.454,
										height: 45.826,
										transform: "translate(-12.977 3.698) rotate(-18.077)",
										fill: "#7284fa"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13124",
								"data-name": "Group 13124",
								transform: "translate(12.595 26.052)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13123",
									"data-name": "Group 13123",
									clipPath: "url(#tasks-empty-state-clip-path-15)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16342",
										"data-name": "Rectangle 16342",
										width: 85.639,
										height: 85.064,
										transform: "matrix(0.68, -0.733, 0.733, 0.68, -32.923, 35.37)",
										fill: "url(#tasks-empty-state-linear-gradient)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13126",
								"data-name": "Group 13126",
								transform: "translate(29.118 25.549)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13125",
									"data-name": "Group 13125",
									clipPath: "url(#tasks-empty-state-clip-path-16)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16343",
										"data-name": "Rectangle 16343",
										width: 9.502,
										height: 7.653,
										transform: "matrix(0.846, -0.533, 0.533, 0.846, -1.476, 0.929)",
										fill: "url(#tasks-empty-state-linear-gradient-8)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13128",
								"data-name": "Group 13128",
								transform: "translate(0 0)",
								children: /* @__PURE__ */ _jsxs("g", {
									id: "Group_13127",
									"data-name": "Group 13127",
									clipPath: "url(#tasks-empty-state-clip-path-3)",
									children: [/* @__PURE__ */ _jsx("path", {
										id: "Path_37842",
										"data-name": "Path 37842",
										d: "M298.672,171.8a4.85,4.85,0,0,1,1.839-2.992c1.216-.966,1.463-1.063,1.88-1.143l.57-.086.062,0a5.683,5.683,0,0,1,1.516.538c.581.409.153,3.3-1.608,6.9l-.208.914c1.535.27,1.915.547,1.927.768.026.479-1.655,1.09-3.212,1.13-1.953.05-4.027-.791-3.988-1.418.016-.254.385-.567,1.8-.875l.665-.935c-.2-.244-1.407-1.565-1.247-2.8",
										transform: "translate(-267.25 -150.567)",
										fill: "#fcdcbd"
									}), /* @__PURE__ */ _jsx("path", {
										id: "Path_37843",
										"data-name": "Path 37843",
										d: "M325.231,202.319c.443-.265.781.3.572.8a.984.984,0,0,1-1.335.513c-.425-.3.167-.959.763-1.316",
										transform: "translate(-291.394 -181.716)",
										fill: "#e8caad"
									})]
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13130",
								"data-name": "Group 13130",
								transform: "translate(31.843 15.358)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13129",
									"data-name": "Group 13129",
									clipPath: "url(#tasks-empty-state-clip-path-18)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16345",
										"data-name": "Rectangle 16345",
										width: 78.078,
										height: 72.703,
										transform: "translate(-20.919 13.076) rotate(-32.176)",
										fill: "url(#tasks-empty-state-linear-gradient-2)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13132",
								"data-name": "Group 13132",
								transform: "translate(0 7.406)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13131",
									"data-name": "Group 13131",
									clipPath: "url(#tasks-empty-state-clip-path-19)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_16346",
										"data-name": "Rectangle 16346",
										width: 48.296,
										height: 47.942,
										transform: "translate(-18.645 20.087) rotate(-47.175)",
										fill: "#7284fa"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_13139",
								"data-name": "Group 13139",
								transform: "translate(0 0)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_13138",
									"data-name": "Group 13138",
									clipPath: "url(#tasks-empty-state-clip-path-3)",
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_13137",
										"data-name": "Group 13137",
										transform: "translate(12.595 52.162)",
										opacity: .3,
										style: {
											mixBlendMode: "multiply",
											isolation: "isolate"
										},
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_13136",
											"data-name": "Group 13136",
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_13135",
												"data-name": "Group 13135",
												clipPath: "url(#tasks-empty-state-clip-path-21)",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_13134",
													"data-name": "Group 13134",
													transform: "translate(0 0)",
													children: /* @__PURE__ */ _jsx("g", {
														id: "Group_13133",
														"data-name": "Group 13133",
														clipPath: "url(#tasks-empty-state-clip-path-22)",
														children: /* @__PURE__ */ _jsx("rect", {
															id: "Rectangle_16347",
															"data-name": "Rectangle 16347",
															width: 64.984,
															height: 58.821,
															transform: "translate(-15.732 7.582) rotate(-25.934)",
															fill: "url(#tasks-empty-state-linear-gradient-10)"
														})
													})
												})
											})
										})
									})
								})
							})
						]
					})
				})
			]
		})
	})]
});
export default SvgTasksWidgetEmptyState;
